import { HTMLAttributes } from 'react';
import { openUrlWithNewWindow, useJoveBreakpoint } from '@jove-frontend/uikit';
import { FileDownload, UnfoldMoreOutlined } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import clsx from 'clsx';

type BrokerTechnicalDocumentsViewProps = HTMLAttributes<HTMLDivElement> & {
  info: {
    technicalDocumentsTitle: string;
    technicalDocumentsTableHeaderDescription: string;
    technicalDocumentsTableHeaderDocumentType: string;
    technicalDocumentsTableHeaderDownload: string;
    technicalDocumentsTableList: Array<{
      desc: string;
      docType: string;
      fileUrl: string;
    }>;
  };
};

const BrokerTechnicalDocumentsView = (props: BrokerTechnicalDocumentsViewProps) => {
  const { className, info } = props;
  const { isMobileLayout } = useJoveBreakpoint();

  /**
   * methods
   */
  const openFileAction = (item) => {
    if (item?.fileUrl) {
      openUrlWithNewWindow(item.fileUrl);
    }
  };

  return (
    <Box className={clsx('flex flex-col items-center', className)}>
      <Box className={clsx('flex flex-col items-center', isMobileLayout ? 'w-full space-y-8' : 'w-[960px] space-y-12')}>
        <Typography variant="h4" className="text-primary-black text-center font-black">
          {info?.technicalDocumentsTitle}
        </Typography>
        <Box className="flex w-full flex-col space-y-3">
          <Box className="flex h-12 w-full flex-row rounded-lg bg-[#05004F] px-4">
            <Box className="flex flex-row items-center space-x-1" style={{ flex: 2 }}>
              <Typography variant="subtitle2" className="text-white">
                {info?.technicalDocumentsTableHeaderDescription}
              </Typography>
              <UnfoldMoreOutlined className="h-5 w-5 text-white" />
            </Box>
            <Box className="flex flex-1 flex-row items-center space-x-1">
              <Typography variant="subtitle2" className="text-white">
                {info?.technicalDocumentsTableHeaderDocumentType}
              </Typography>
              <UnfoldMoreOutlined className="h-5 w-5 text-white" />
            </Box>
            <Box className="flex flex-1 flex-row items-center justify-end  space-x-1">
              <Typography variant="subtitle2" className="text-white">
                {info?.technicalDocumentsTableHeaderDownload}
              </Typography>
            </Box>
          </Box>
          {(info?.technicalDocumentsTableList || []).map((item, index) => {
            return (
              <Box key={index} className="flex min-h-12 w-full flex-row rounded-lg bg-white px-4">
                <Box className="flex flex-row items-center space-x-1" style={{ flex: 2 }}>
                  <Typography variant="subtitle2" className="text-primary-black">
                    {item.desc}
                  </Typography>
                </Box>
                <Box className="flex flex-1 flex-row items-center space-x-1">
                  <Typography variant="subtitle2" className="text-primary-black">
                    {item.docType}
                  </Typography>
                </Box>
                <Box className="flex flex-1 flex-row items-center justify-end space-x-1">
                  <IconButton onClick={() => openFileAction(item)}>
                    <FileDownload className="text-brand-secondary" />
                  </IconButton>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default BrokerTechnicalDocumentsView;
